module.exports = __webpack_public_path__ + "assets/img/c4004a04699718784380f133e230a2d3.png";